import type { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";

import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import { OrgProvider } from "@/contexts/OrgContext";
import { UserProfileProvider } from "@/contexts/UserProfileContext";
import { queryClient } from "@/lib/query";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <UserProfileProvider>
          <OrgProvider>
            <TooltipProvider delayDuration={300}>{children}</TooltipProvider>
          </OrgProvider>
        </UserProfileProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}
